module.exports = __webpack_public_path__ + "static/media/heart.be94008f.svg";